/* eslint-disable react/static-property-placement */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable @typescript-eslint/ban-types */

//
import PropTypes from "prop-types"
import { Component } from "react"

import { genericFilterGroup, createPACTransactionsFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import { createCustomFilterGroup } from "shared/search/containers/FilterGroup/CustomFilterGroup"
import { createProjectFilterGroup } from "shared/search/containers/FilterGroup/ProjectFilterGroup"
import { createStakeholderFilterGroup } from "shared/search/containers/FilterGroup/StakeholderFilterGroup"
import {
    allRegionsExceptUS,
    euRegion,
    federalAndStates,
    hasFederal,
    internationalRegions,
    isAllEURegions,
    isInternational,
    isSingleCountry,
    notInternationalEURegions,
    usEURegion,
    usRegions,
} from "shared/imports/regionConstants"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    // representing geo
    RepresentingStateFilter,
    RepresentingDistrictFilter,
    RepresentingUpperLDFilter,
    RepresentingDistrictPrimaryFilter,
    RepresentingUpperLDPrimaryFilter,
    RepresentingLowerLDPrimaryFilter,
    RepresentingLowerLDFilter,
    RepresentingCountyFilter,
    RepresentingMunicipalityFilter,
    RepresentingSchoolDistrictFilter,
    // emails
    UnsubscribedEmailFilter,
    ReceivedOutboxEmailFilter,
    OpenedOutboxEmailFilter,
    DidNotOpenOutboxEmailFilter,
    ClickedLinkOutboxEmailFilter,
    DidNotClickLinkOutboxEmailFilter,
    RepliedOutboxEmailFilter,
    DidNotReplyOutboxEmailFilter,
    PopulationStratumFilter,
    PriorityFilter,
    PriorityLastUserFilter,
} from "shared/search/containers/Filter/Filters"

import {
    CustomOfficialsFilter,
    OfficialTypeFilter,
    EUMinorRoleFilter,
    OfficialInternationalTypeFilter,
    LegislatorTypeFilter,
    ExecutiveTypeFilter,
    LocalExecutiveTypeFilter,
    PersonStatusFilter,
    DateAssumedOfficeAfterFilter,
    DateAssumedOfficeBeforeFilter,
    FirstElectedAfterFilter,
    FirstElectedBeforeFilter,
    LegislativeSeniorityFilter,
    LegislativeLeadershipFilter,
    NumberOfTermsFilter,
    ExecutiveWorksForFilter,
    ExecutiveTitleFilter,
    OfficialPayScaleFilter,
    OfficialAppointedByTypeFilter,
    OfficialPartyFilter,
    OfficialPartyInternationalFilter,
    LegislatorOnCommitteeFilter,
    LegislatorOnCaucusFilter,
    LegislatorOnCommitteeTypeFilter,
    ChairOnCommitteeFilter,
    PersonRepresentingAddressFilter,
    PersonRepresentingCustomGeographyFilter,
    PersonRepresentingCountryAllFilter,
    PersonRepresentingCountryEUFilter,
    PersonRepresentingCanadianFederalElectoralDistrictFilter,
    PersonRepresentingContactsFilter,
    PersonInteractedInNotesFilter,
    PersonInteractedDateFilter,
    PersonNotInteractedDateFilter,
    OfficeInteractedInNotesFilter,
    LegislatorSponsoredFilter,
    LegislatorCosponsoredFilter,
    LegislatorSponsoredOrCosponsoredFilter,
    LegislatorDidNotSponsorOrCosponsorFilter,
    LegislatorVotedYesFilter,
    LegislatorVotedNoFilter,
    LegislatorRapporteurFilter,
    LegislatorShadowRapporteurFilter,
    LegislatorShadowOrRapporteurFilter,
    PersonAgeFilter,
    PersonBirthdayPickerStartNoFutureFilter,
    PersonBirthdayPickerEndNoFutureFilter,
    PersonBioSearchFilter,
    PersonCustomBioSearchFilter,
    PersonGenderFilter,
    PersonMilitaryFilter,
    PersonEthnicityFilter,
    PersonReligionFilter,
    PersonDegreeFilter,
    PersonUniversityFilter,
    PersonDocumentFilter,
    OfficialFromBulkUploadFilter,
    OfficialLastModifiedByFilter,
    PersonDonationAggregateFilter,
    PersonNextElectionFilter,
    PressContactFromBulkUploadFilter,

    // Official Custom Event Filters
    OfficialCustomEventFilter,
    OfficialInvitedToEventCustomEventFilter,
    OfficialHasNotRsvpCustomEventFilter,
    OfficialHasRsvpYesCustomEventFilter,
    OfficialHasRsvpNoCustomEventFilter,
    OfficialHasRsvpMaybeCustomEventFilter,
    OfficialAttendedCustomEventFilter,

    // Press Custom Event Filters
    PressContactCustomEventFilter,
    PressContactDMAFilter,
    PressContactInvitedToEventCustomEventFilter,
    PressContactHasNotRsvpCustomEventFilter,
    PressContactHasRsvpYesCustomEventFilter,
    PressContactHasRsvpNoCustomEventFilter,
    PressContactHasRsvpMaybeCustomEventFilter,
    PressContactAttendedCustomEventFilter,
    PressContactSocialMediaFilter,
    PersonCampaignFilter,
    PersonTargetedByCampaignFilter,
    PersonTitleFilter,
    PressContactAddressFilter,
    PressContactArticleFilter,
    PressContactBeatFilter,
    PressContactCountryFilter,
    PressContactCountryEUFilter,
    PressContactCountyFilter,
    PressContactLanguageFilter,
    PressContactMajorRoleTypeFilter,
    PressContactMunicipalityFilter,
    PressContactOutletCirculationFilter,
    PressContactOutletCoverageFilter,
    PressContactOutletFilter,
    PressContactOutletFrequencyFilter,
    PressContactOutletLanguageFilter,
    PressContactOutletTypeFilter,
    PressContactStateFilter,
    CommitteeLeadershipFilter,
    // campaign finance
    OfficialsCampaignFinanceReceivedMoneyFilter,
    OfficialsCampaignFinanceReceiptsAmountMinFilter,
    OfficialsCampaignFinanceReceiptsAmountMaxFilter,
    OfficialsCampaignFinanceReceiptsDateStartFilter,
    OfficialsCampaignFinanceReceiptsDateEndFilter,
    OfficialsCampaignFinanceReceiptsContributorCommitteesFilter,
    OfficialsCampaignFinanceReceiptsLegislatorFilter,

    // bill profile
    OfficialSponsorBillProfileFilter,
    // organization profile
    OfficialOrganizatonsFilter,

    // EU official
    EUOfficialTypeFilter,
    OfficialsRepresentingSchoolDistrictEnrollmentMaxFilter,
    OfficialsRepresentingSchoolDistrictEnrollmentMinFilter,
} from "shared/search/containers/Filter/OfficialFilters"

import { StafferWorksForOfficialEUFilter } from "shared/search/containers/Filter/StafferFilters"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import {
    checkIfShouldShowSchoolBoard,
    isNotAbleToViewSensitiveFields,
    hasAnyPermission,
} from "shared/imports/permissionFunctions"
import { bulkUploadIsAvailable } from "shared/search/helperFunctions"
import { createPacClassicPacTransactionAmountFilter } from "shared/search/containers/Filter/PacClassicPacTransactionFilters"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const OfficialCustomFilterGroup = createCustomFilterGroup(
    "officialCustomFilterGroup",
    DjangIO.app.models.QuorumDataType.person.value,
)
export const PersonStakeholderFilterGroup = createStakeholderFilterGroup("personStakeholderFilterGroup")
export const PersonProjectFilterGroup = createProjectFilterGroup("personProjectFilterGroup")
const { isExclusivelySchoolBoard, canSeeSchoolBoards } = checkIfShouldShowSchoolBoard()

export class OfficialTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [
            Userdata.isOnlyEUMode() ? EUMinorRoleFilter : OfficialTypeFilter,
            // For School Boards, we need to check if the user doesn't have other local permissions.
            // This is due the overlapping between both permissions and what we actually need to show in the filter.
            ...(isExclusivelySchoolBoard
                ? []
                : [EUOfficialTypeFilter, OfficialInternationalTypeFilter, PersonTitleFilter, PersonStatusFilter]),
            ...(isFeatureEnabled("ff_lc_kw_failover") ? [LocalExecutiveTypeFilter] : []), // Local Executives will be included in OfficialTypeFilter
            ...(isFeatureEnabled("ff_custom_official") && Userdata.admin_can_create_custom_official
                ? [CustomOfficialsFilter]
                : []),
        ],
        uniqueFilterGroupId: "officialTypeFilterGroup",
        displayLabel: Userdata.isOnlyEUMode() ? "Person Type" : "Official Type",
        helpText: Userdata.isOnlyEUMode()
            ? "Filter for people based on the type of role they have"
            : "Filter officials (legislators, executives, local) by role type and status.",
        dataCy: "official-type-filter-group",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const LegislatorTypeFilterGroup = (props) => genericFilterGroup(props)
LegislatorTypeFilterGroup.defaultProps = {
    filters: [LegislatorTypeFilter, PersonStatusFilter],
    uniqueFilterGroupId: "legislatorTypeFilterGroup",
    displayLabel: "Legislator Type",
    helpText: "Filter legislators by type.",
}

export const ExecutiveTypeFilterGroup = (props) => genericFilterGroup(props)
ExecutiveTypeFilterGroup.defaultProps = {
    filters: [ExecutiveTypeFilter, PersonStatusFilter],
    uniqueFilterGroupId: "executiveTypeFilterGroup",
    displayLabel: "Executive Type",
    helpText: "Filter executives by type.",
}
export class OfficialLegislativeRoleFilterGroup extends Component {
    static defaultProps = {
        filters: [LegislativeSeniorityFilter, LegislativeLeadershipFilter, NumberOfTermsFilter],
        uniqueFilterGroupId: "officialLegRoleFilterGroup",
        displayLabel: "Legislative Role",
        regions: federalAndStates,
        helpText: "Filter legislators by seniority, leadership roles, \nlegislative sessions, and number of terms",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialExecutiveRoleFilterGroup extends Component {
    static defaultProps = {
        filters: [
            ExecutiveWorksForFilter,
            ExecutiveTitleFilter,
            ...(isFeatureEnabled("ff_lc_kw_failover") ? [OfficialPayScaleFilter, OfficialAppointedByTypeFilter] : []),
        ],
        uniqueFilterGroupId: "officialExecRoleFilterGroup",
        displayLabel: "Executive Role",
        regions: usRegions,
        helpText: isFeatureEnabled("ff_lc_kw_failover")
            ? hasFederal
                ? "Filter executive branch officials by organization, title, appointment type, and pay scale."
                : "Filter executive branch officials by organization, title, and appointment type."
            : "Filter executives by organization worked for and title.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialPartyFilterGroup extends Component {
    static defaultProps = {
        filters: [OfficialPartyFilter, OfficialPartyInternationalFilter],
        uniqueFilterGroupId: "personPartyFilterGroup",
        displayLabel: "Party",
        helpText: "Filter officials by party.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonPriorityFilterGroup extends Component {
    static defaultProps = {
        filters: [PriorityFilter, PriorityLastUserFilter],
        uniqueFilterGroupId: "personPriorityFilterGroup",
        displayLabel: "Priority",
        helpText: "Filter by your organization's indicated priority.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialAssumedOfficeFilterGroup extends Component {
    static defaultProps = {
        filters: [
            FirstElectedAfterFilter,
            FirstElectedBeforeFilter,
            DateAssumedOfficeAfterFilter,
            DateAssumedOfficeBeforeFilter,
            ...(isNotAbleToViewSensitiveFields() ? [] : [PersonNextElectionFilter]),
        ],
        uniqueFilterGroupId: "officialAssumedOfficeFilterGroup",
        displayLabel: "Date",
        helpText: "Filter for officials by the date they assumed office, or the date they were elected.",
        regions: federalAndStates,
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialWorksForFilterGroup extends Component {
    static defaultProps = {
        filters: [ExecutiveWorksForFilter, StafferWorksForOfficialEUFilter],
        uniqueFilterGroupId: "officialEUWorksForFilterGroup",
        displayLabel: isInternational ? "Organizations" : "Works For",
        regions: allRegionsExceptUS,
        helpText: "Filter for people based on the organization that they are a part of.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const OfficialsCampaignFinanceFilterGroup = (props) => genericFilterGroup(props)
OfficialsCampaignFinanceFilterGroup.propTypes = defaultProps
OfficialsCampaignFinanceFilterGroup.defaultProps = {
    filters: [
        // Receipts Filters
        OfficialsCampaignFinanceReceivedMoneyFilter,
        OfficialsCampaignFinanceReceiptsContributorCommitteesFilter,
        OfficialsCampaignFinanceReceiptsLegislatorFilter,
        OfficialsCampaignFinanceReceiptsAmountMinFilter,
        OfficialsCampaignFinanceReceiptsAmountMaxFilter,
        OfficialsCampaignFinanceReceiptsDateStartFilter,
        OfficialsCampaignFinanceReceiptsDateEndFilter,
    ],
    permissions: [DjangIO.app.models.PermissionType.campaign_finance],
    userPermissions: [DjangIO.app.models.PermissionType.can_access_campaign_finance],
    uniqueFilterGroupId: "officialsCampaignFinanceFilterGroup",
    displayLabel: "Campaign Finance",
    helpText: "Filter officials by their contributions.",
}

export class OfficialCommitteeFilterGroup extends Component {
    static defaultProps = {
        filters: [
            LegislatorOnCommitteeFilter,
            LegislatorOnCaucusFilter,
            CommitteeLeadershipFilter,
            ChairOnCommitteeFilter,
            LegislatorOnCommitteeTypeFilter,
        ],
        uniqueFilterGroupId: "officialCommFilterGroup",
        displayLabel: Userdata.isFederalMode() ? "Committees & Caucuses" : "Committees",
        regions: usEURegion,
        helpText: "Filter legislators by the committees they sit on.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialCampaignFilterGroup extends Component {
    static defaultProps = {
        filters: [PersonCampaignFilter, PersonTargetedByCampaignFilter],
        uniqueFilterGroupId: "officialCampaignFilterGroup",
        displayLabel: "Grassroots Activity",
        regions: usEURegion,
        helpText: "Filter legislators by campaigns they were contacted in.",
        permissions: [DjangIO.app.models.PermissionType.action_center],
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonRepresentsRegionFilterGroup extends Component {
    static defaultProps = {
        filters: [
            PersonRepresentingAddressFilter,
            RepresentingStateFilter,
            RepresentingDistrictFilter,
            RepresentingUpperLDFilter,
            RepresentingLowerLDFilter,
            RepresentingCountyFilter,
            RepresentingMunicipalityFilter,
            ...(canSeeSchoolBoards
                ? [
                      RepresentingSchoolDistrictFilter,
                      ...(isFeatureEnabled("ff_school_board_orgs_and_officials")
                          ? [
                                OfficialsRepresentingSchoolDistrictEnrollmentMinFilter,
                                OfficialsRepresentingSchoolDistrictEnrollmentMaxFilter,
                            ]
                          : []),
                  ]
                : []),
            // Primary GeoMemberships
            RepresentingDistrictPrimaryFilter,
            RepresentingUpperLDPrimaryFilter,
            RepresentingLowerLDPrimaryFilter,
            PopulationStratumFilter,
            PersonRepresentingCustomGeographyFilter,
            // We don't want the "country" filter to appear when it's just 1 region...
            // or if it's multiple regions all within the US
            ...(!isSingleCountry && isAllEURegions ? [PersonRepresentingCountryEUFilter] : []),
            ...(!isSingleCountry && !isAllEURegions ? [PersonRepresentingCountryAllFilter] : []),
        ],
        uniqueFilterGroupId: "personRepresentsRegionFilterGroup",
        displayLabel: "Region",
        regions: notInternationalEURegions,
        helpText: Userdata.isOnlyEUMode()
            ? "Filter by the member state an official represents."
            : "Filter by the geographical areas people " +
              "represent or by a particular address. If you choose a given region " +
              "(for example, New York City), we will return all whose " +
              "districts at all overlap that region.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonRepresentsInternationalRegionFilterGroup extends Component {
    static defaultProps = {
        filters: [
            // "the data that pulls from searching a city/town in isn't consistent enough to have just yet.
            // We want to do more work on the international region search filter before we make this live to users"
            // https://github.com/QuorumUS/issues/issues/10183
            // PersonInternationalRegionFilter,
            // We don't want the "country" filter to appear when it's just 1 region...
            // or if it's multiple regions all within the US
            ...(!isSingleCountry && isAllEURegions ? [PersonRepresentingCountryEUFilter] : []),
            ...(!isSingleCountry && !isAllEURegions ? [PersonRepresentingCountryAllFilter] : []),
            PersonRepresentingAddressFilter,
            PersonRepresentingCanadianFederalElectoralDistrictFilter,
            PopulationStratumFilter,
            RepresentingCountyFilter,
            RepresentingDistrictFilter,
            RepresentingLowerLDFilter,
            RepresentingMunicipalityFilter,
            RepresentingStateFilter,
            RepresentingUpperLDFilter,
            // Primary GeoMemberships
            RepresentingDistrictPrimaryFilter,
            RepresentingUpperLDPrimaryFilter,
            RepresentingLowerLDPrimaryFilter,
            PersonRepresentingCustomGeographyFilter,
        ],
        uniqueFilterGroupId: "personRepresentsInternationalRegionFilterGroup",
        displayLabel: "Region",
        regions: internationalRegions,
        helpText: "Filter by region.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonRepresentingFilterGroup extends Component {
    static defaultProps = {
        filters: [PersonRepresentingContactsFilter],
        uniqueFilterGroupId: "personRepresentingFilterGroup",
        displayLabel: "Contacts",
        helpText: "Filter by the contacts people represent.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.person.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.person.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "personListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter results by the lists that you have saved them to in Issue Management.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PressContactListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.press_contact.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.press_contact.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "pressContactListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter results by the lists that you have saved them to in Issue Management.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonInteractionFilterGroup extends Component {
    static defaultProps = {
        filters: [
            PersonInteractedInNotesFilter,
            OfficeInteractedInNotesFilter,
            PersonDonationAggregateFilter,
            PersonInteractedDateFilter,
            PersonNotInteractedDateFilter,
        ],
        uniqueFilterGroupId: "memberSecondFilterGroup",
        displayLabel: "Interactions",
        permissions: [
            DjangIO.app.models.PermissionType.internal_relationship,
            DjangIO.app.models.PermissionType.external_relationship,
            DjangIO.app.models.PermissionType.external_interactions,
        ],
        helpText:
            "Filter individuals by the notes they've participated in, by the time since " +
            "your most recent interaction, or by the time since there has been no logged " +
            "interaction.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PersonOutboxFilterGroup extends Component {
    static defaultProps = {
        filters: [
            UnsubscribedEmailFilter,
            ReceivedOutboxEmailFilter,
            OpenedOutboxEmailFilter,
            DidNotOpenOutboxEmailFilter,
            ClickedLinkOutboxEmailFilter,
            DidNotClickLinkOutboxEmailFilter,
            RepliedOutboxEmailFilter,
            DidNotReplyOutboxEmailFilter,
        ],
        uniqueFilterGroupId: "personOutboxFilterGroup",
        displayLabel: "Outbox Emails",
        helpText:
            "Filter individuals based on the emails you’ve sent them via Outbox over the last 12 months - " +
            "whether they’ve opened, clicked or replied to your emails.",
        permissions: [DjangIO.app.models.PermissionType.officials_outbox],
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialLegislativeActionsFilterGroup extends Component {
    static defaultProps = {
        filters: [
            LegislatorSponsoredFilter,
            LegislatorCosponsoredFilter,
            LegislatorSponsoredOrCosponsoredFilter,
            LegislatorDidNotSponsorOrCosponsorFilter,
            LegislatorVotedYesFilter,
            LegislatorVotedNoFilter,
        ],
        uniqueFilterGroupId: "officialLegActionsFilterGroup",
        displayLabel: "Legislative Actions",
        regions: federalAndStates,
        helpText: "Filter legislators by bills they sponsored, cosponsored, or voted on.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class EULegislativeActionsFilterGroup extends Component {
    static defaultProps = {
        filters: [LegislatorRapporteurFilter, LegislatorShadowRapporteurFilter, LegislatorShadowOrRapporteurFilter],
        uniqueFilterGroupId: "euOfficialLegActionsFilterGroup",
        displayLabel: "Legislative Actions",
        regions: euRegion,
        helpText: "Filter legislators by bills they rapporteur on, shadow rapporteur on, or both.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialBiographyFilterGroup extends Component {
    static defaultProps = {
        filters: [
            ...(isNotAbleToViewSensitiveFields()
                ? []
                : [PersonAgeFilter, PersonBirthdayPickerStartNoFutureFilter, PersonBirthdayPickerEndNoFutureFilter]),
            PersonBioSearchFilter,
            PersonCustomBioSearchFilter,
            PersonGenderFilter,
            PersonMilitaryFilter,
            //conditional to see if user is part of org that limits this info
            ...(isFeatureEnabled("ff_lc_kw_failover") || isNotAbleToViewSensitiveFields()
                ? []
                : [PersonEthnicityFilter]),
            ...(isNotAbleToViewSensitiveFields() ? [] : [PersonReligionFilter]),
            PersonDegreeFilter,
            PersonUniversityFilter,
        ],
        uniqueFilterGroupId: "officialBioFilterGroup",
        displayLabel: "Biographical Information",
        helpText: "Filter officials by biographical information.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class OfficialDataMaintenanceFilterGroup extends Component {
    static defaultProps = {
        filters: bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.official)
            ? [OfficialFromBulkUploadFilter, OfficialLastModifiedByFilter]
            : [],
        uniqueFilterGroupId: "officialDataMaintenanceFilterGroup",
        displayLabel: "Data Maintenance",
        helpText: "Filter officials by source.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

// Bill Profile Specific Filter Group
export const LegislatorBillSponsorGroup = (props) => genericFilterGroup(props)
LegislatorBillSponsorGroup.defaultProps = {
    filters: [OfficialSponsorBillProfileFilter],
    uniqueFilterGroupId: "officialSponsorFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export const PersonDocumentFilterGroup = (props) => genericFilterGroup(props)
PersonDocumentFilterGroup.propTypes = defaultProps
PersonDocumentFilterGroup.defaultProps = {
    filters: [PersonDocumentFilter],
    uniqueFilterGroupId: "personDocumentFilterGroup",
    displayLabel: "Documents",
    helpText: "Filter results by associated document.",
}

export const PersonOrganizationProfileFilterGroup = (props) => genericFilterGroup(props)
PersonOrganizationProfileFilterGroup.propTypes = defaultProps
PersonOrganizationProfileFilterGroup.defaultProps = {
    filters: [OfficialOrganizatonsFilter],
    uniqueFilterGroupId: "personOrganizationProfileFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export const OfficialCustomEventFilterGroup = (props) => genericFilterGroup(props)
OfficialCustomEventFilterGroup.propTypes = defaultProps
OfficialCustomEventFilterGroup.defaultProps = {
    filters: [
        OfficialCustomEventFilter,
        OfficialInvitedToEventCustomEventFilter,
        OfficialHasNotRsvpCustomEventFilter,
        OfficialHasRsvpYesCustomEventFilter,
        OfficialHasRsvpNoCustomEventFilter,
        OfficialHasRsvpMaybeCustomEventFilter,
        OfficialAttendedCustomEventFilter,
    ],
    permissions: [DjangIO.app.models.PermissionType.custom_events],
    uniqueFilterGroupId: "officialCustomEventFilterGroup",
    displayLabel: "Events",
    helpText: "Filter officials by the event that they are participating in.",
}

export const PressContactCustomFilterGroup = createCustomFilterGroup(
    "pressContactCustomFilterGroup",
    DjangIO.app.models.QuorumDataType.press_contact.value,
)

export const PressContactLanguageFilterGroup = (props) => genericFilterGroup(props)
PressContactLanguageFilterGroup.propTypes = defaultProps
PressContactLanguageFilterGroup.defaultProps = {
    filters: [PressContactLanguageFilter],
    uniqueFilterGroupId: "pressContactLanguageFilterGroup",
    displayLabel: "Language",
    helpText: "Filter for results with a specific language.",
}

export const PressContactTypeFilterGroup = (props) => genericFilterGroup(props)
PressContactTypeFilterGroup.propTypes = defaultProps
PressContactTypeFilterGroup.defaultProps = {
    filters: [PressContactMajorRoleTypeFilter, PersonTitleFilter, PressContactBeatFilter, PersonStatusFilter],
    uniqueFilterGroupId: "pressContactTypeFilterGroup",
    displayLabel: "Person Type",
    helpText: "Filter Press by title",
}

export const PressContactOutletFilterGroup = (props) => genericFilterGroup(props)
PressContactOutletFilterGroup.propTypes = defaultProps
PressContactOutletFilterGroup.defaultProps = {
    filters: [
        PressContactOutletFilter,
        PressContactOutletTypeFilter,
        PressContactOutletCoverageFilter,
        PressContactOutletFrequencyFilter,
        PressContactOutletCirculationFilter,
        PressContactOutletLanguageFilter,
    ],
    uniqueFilterGroupId: "pressContactOutletFilterGroup",
    displayLabel: "Media Outlet",
    helpText: "Filter Press by outlet",
}

export class PressContactRegionFilterGroup extends Component {
    static defaultProps = {
        filters: [
            PressContactAddressFilter,
            PressContactCountryFilter,
            PressContactStateFilter,
            PressContactCountyFilter,
            PressContactDMAFilter,
            PressContactMunicipalityFilter,
            PressContactCountryEUFilter,
            // RepresentingDistrictFilter,
            // RepresentingUpperLDFilter,
            // RepresentingLowerLDFilter,
            // PersonRepresentingCustomGeographyFilter,
        ],
        uniqueFilterGroupId: "pressContactRegionFilterGroup",
        displayLabel: "Region",
        helpText: "Filter by the geographical areas people reside or by a particular address.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class PressContactNewsArticlesFilterGroup extends Component {
    static defaultProps = {
        filters: [PressContactArticleFilter],
        uniqueFilterGroupId: "pressContactArticlesFilterGroup",
        displayLabel: "News Articles",
        helpText: "Filter News Articles written by Press Contacts.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const PressContactCustomEventFilterGroup = (props) => genericFilterGroup(props)
PressContactCustomEventFilterGroup.propTypes = defaultProps
PressContactCustomEventFilterGroup.defaultProps = {
    filters: [
        PressContactCustomEventFilter,
        PressContactInvitedToEventCustomEventFilter,
        PressContactHasNotRsvpCustomEventFilter,
        PressContactHasRsvpYesCustomEventFilter,
        PressContactHasRsvpNoCustomEventFilter,
        PressContactHasRsvpMaybeCustomEventFilter,
        PressContactAttendedCustomEventFilter,
    ],
    permissions: [DjangIO.app.models.PermissionType.custom_events],
    uniqueFilterGroupId: "pressContactCustomEventFilterGroup",
    displayLabel: "Events",
    helpText: "Filter press by the event that they are participating in.",
}

export class PressContactInteractionFilterGroup extends Component {
    static defaultProps = {
        filters: [PersonInteractedInNotesFilter, PersonInteractedDateFilter, PersonNotInteractedDateFilter],
        uniqueFilterGroupId: "pressContactInteractionFilterGroup",
        displayLabel: "Interactions",
        permissions: [
            DjangIO.app.models.PermissionType.internal_relationship,
            DjangIO.app.models.PermissionType.external_relationship,
            DjangIO.app.models.PermissionType.external_interactions,
        ],
        helpText:
            "Filter individuals by the notes they've participated in, by the time since " +
            "your most recent interaction, or by the time since there has been no logged " +
            "interaction.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const PressContactSocialMediaFilterGroup = (props) => genericFilterGroup(props)
PressContactSocialMediaFilterGroup.propTypes = defaultProps
PressContactSocialMediaFilterGroup.defaultProps = {
    filters: [PressContactSocialMediaFilter],
    uniqueFilterGroupId: "pressContactSocialMediaFilterGroup",
    displayLabel: "Social Media",
    helpText: "Filter Press by Social Media Documents",
}

export const OfficialPACTransactionsFilterGroup = createPACTransactionsFilterGroup({
    displayLabel: "PAC Activity",
    quorumDataType: DjangIO.app.models.QuorumDataType.person,
    uniqueFilterGroupId: "officialPACFilterGroup",
})

export class PressContactDataMaintenanceFilterGroup extends Component {
    static defaultProps = {
        filters: bulkUploadIsAvailable(DjangIO.app.custom_data.types.BulkUploadType.press_contact)
            ? [PressContactFromBulkUploadFilter, OfficialLastModifiedByFilter]
            : [],
        uniqueFilterGroupId: "pressContactDataMaintenanceFilterGroup",
        displayLabel: "Data Maintenance",
        helpText: "Filter press contacts by source.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const PacClassicOfficialPACActivityFilterGroup = (props) => genericFilterGroup(props)
PacClassicOfficialPACActivityFilterGroup.defaultProps = {
    filters: [
        ...(hasAnyPermission([DjangIO.app.models.PermissionType.pac_hybrid])
            ? [
                  createPacClassicPacTransactionAmountFilter({
                      quorumDataType: DjangIO.app.models.QuorumDataType.person,
                  }),
              ]
            : []),
    ],
    uniqueFilterGroupId: "pacClassicOfficialPACActivityFilterGroup",
    displayLabel: "PAC Activity",
    helpText: "Filter Officials by PAC Activity",
}
